import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import SectionHeading from "@/components/base/SectionHeading";

export default function TopicSection() {
  return (
    <section id="topics" className="scroll-mt-40">
      <SectionHeading
        eyebrow="主题分类"
        title="按兴趣挑，只看你在意的那个圈"
        desc="六个常设栏目，覆盖恋情、作品、综艺、造型、舞台与行业观察。"
        moreText="浏览全部分类"
        morePath="/daily"
      />

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/daily?category=${cat.slug}`}
            className="group overflow-hidden rounded-card border border-background-200/80 bg-background-50 transition-colors duration-200 hover:border-primary-200"
          >
            <div className="h-40 w-full overflow-hidden bg-background-200">
              <img
                src={cat.image}
                alt={`${cat.name}话题配图`}
                title={`${cat.name} - 爆料吃瓜分类`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center justify-between">
                <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950 transition-colors duration-200 group-hover:text-primary-700">
                  <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                    <i className={`${cat.icon} text-base`}></i>
                  </span>
                  {cat.name}
                </h3>
                <span className="text-xs text-foreground-500">{cat.count} 条</span>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                进入分类
                <span className="flex h-3.5 w-3.5 items-center justify-center transition-transform duration-200 group-hover:translate-x-0.5">
                  <i className="ri-arrow-right-line text-[13px]"></i>
                </span>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}